export enum SELECT_COMPONENT_TYPES {
    GROUP = 1,
    COMPONENT = 2,
    OTHER = 3
}

export interface SelectComponent {
    id: string;
    icon: string;
    type: SELECT_COMPONENT_TYPES;
    parameters?: any;
    components?: SelectComponent[];
    component_mls: { language: string; title: string; hint?: string }[];
}

export const UNDEFINED_ROOM_TYPE = 1;

export const UNDEFINED_APPLIANCE_TYPE = 1;
